const styles = {
  container: {
    display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        width: "100%",
  },
  label: {
    display: "flex",
    gap: "8px",
    fontSize: "18px",
    display: "flex",
    alignItems: "center",
  },
};

export default styles;
